import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  Col,
  Input,
  Button
} from 'reactstrap';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../components/common/CustomBootstrap';
import {connect} from 'react-redux';
import {reactTableText} from '../constants/configs';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {fixedToWithoutRound, getDatePickerProps, getTokenDecimals} from '../helpers/Utils';
import i18n from '../services/i18n';
import JalaliUtils from '@date-io/jalaali';
import MomentUtils from '@date-io/moment';
import Api from '../services/Api';
import {isEmpty} from 'lodash';
import moment from 'moment';
import Breadcrumb from "./navs/Breadcrumb";
import fa_IR from "../constants/locales";

class ActivityReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      from: null,
      to: null,
      selectedTag: null,
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    const {from, to} = this.state;
    this.setState({loading: true});
    try {
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/filterable-private-statistics',
        null,
        {
          params: {
            mode: 'NONE',
            from: from ? moment(from).toISOString() : null,
            to: to ? moment(to).toISOString() : null,
          },
          cancelToken: null,
        }
      );
      this.setState({
        ...this.state,
        ...data,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    }, async () => {
      await this.fetchData();
    });
  };

  onClickLast24h = () => {
    this.setState({
      selectedTag: 'last24h',
      from: moment().subtract(24, 'hours'),
      to: moment(),
    }, this.fetchData);
  };

  onClickLast7d = () => {
    this.setState({
      selectedTag: 'last7d',
      from: moment().subtract(7, 'days'),
      to: moment(),
    }, this.fetchData);
  };

  onClickLast30d = () => {
    this.setState({
      selectedTag: 'last30d',
      from: moment().subtract(30, 'days'),
      to: moment(),
    }, this.fetchData);
  };

  onClickAll = () => {
    this.setState({
      selectedTag: null,
      from: null,
      to: null,
    }, this.fetchData);
  };

  getColumns = t => [
    {
      accessor: 'logoUrl',
      Cell: props => <img src={props.value} className="avatar-mini" alt={props.original.name}/>,
      width: 60,
    },
    {
      Header: t('Name'),
      accessor: 'localeName',
    },
    {
      Header: t('Deposits'),
      accessor: 'symbol',
      Cell: props => <span>{
        !isEmpty(this.state.deposit) ?
          fixedToWithoutRound(
            Math.abs(this.state.deposit[props.value]),
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
    {
      Header: t('Withdraws'),
      accessor: 'symbol',
      Cell: props => <span>{
        !isEmpty(this.state.withdraw) ?
          fixedToWithoutRound(
            Math.abs(this.state.withdraw[props.value]),
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
    {
      Header: t('Users Trades'),
      accessor: 'symbol',
      minWidth: 140,
      Cell: props => <span>{
        !isEmpty(this.state.user_income) ?
          fixedToWithoutRound(
            Math.abs(this.state.user_income[props.value]),
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
    {
      Header: t('Fees'),
      accessor: 'symbol',
      Cell: props => <span>{
        !isEmpty(this.state.fee) ?
          fixedToWithoutRound(
            Math.abs(this.state.fee[props.value]),
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
    {
      Header: t('Referrals'),
      accessor: 'symbol',
      Cell: props => <span>{
        !isEmpty(this.state.reward) ?
          fixedToWithoutRound(
            Math.abs(this.state.reward[props.value]),
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
  ];

  render() {
    const {t, tokens} = this.props;
    const {from, to, selectedTag} = this.state;
    const newTokens = [...tokens];
    return (
      <ThemeProvider
        theme={createMuiTheme({
          typography: {
            fontFamily: 'IRANSans',
          }})
        }
      >
        <MuiPickersUtilsProvider
          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
          locale={i18n.language}
        >
          <Row>
            <Colxx xxs="12">
              <Breadcrumb match={this.props.match}/>
              <Separator className="mb-5"/>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" className="mb-4">
              <Card className="h-100">
                <CardBody>
                  <Row className="mb-5">
                    <Col className='col-6 col-lg-3'>
                      <span>{t('start date')}</span>
                      <DateTimePicker
                        {...getDatePickerProps()}
                        value={from}
                        TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
                        onChange={date => {
                          this.handleDateChange('from', date);
                        }}
                      />
                    </Col>
                    <Col className='col-6 col-lg-3'>
                      <span>{t('end date')}</span>
                      <DateTimePicker
                        {...getDatePickerProps()}
                        value={to}
                        TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
                        onChange={date => {
                          this.handleDateChange('to', date);
                        }}
                      />
                    </Col>
                    <Col className='col-12 col-lg-6 mt-lg-0 d-flex flex-row align-items-end flex-wrap'>
                      <Button className='mr-3 mt-2' outline={selectedTag !== 'last24h'} onClick={this.onClickLast24h}>{t('last 24 hours')}</Button>
                      <Button className='mr-3 mt-2' outline={selectedTag !== 'last7d'} onClick={this.onClickLast7d}>{t('last 7 days')}</Button>
                      <Button className='mr-3 mt-2' outline={selectedTag !== 'last30d'} onClick={this.onClickLast30d}>{t('last 30 days')}</Button>
                      <Button className='mt-2' outline={!!from || !!to} onClick={this.onClickAll}>{t('from first day')}</Button>
                    </Col>
                  </Row>
                  <ReactTable
                    manual
                    className="-highlight"
                    data={newTokens}
                    loading={this.state.loading}
                    sortable={false}
                    resizable={true}
                    showPagination={false}
                    columns={this.getColumns(t)}
                    defaultPageSize={6}
                    style={{
                      width: '100%'
                    }}
                    {...reactTableText}
                  />
                </CardBody>
              </Card>
            </Colxx>
          </Row>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = state => ({
  tokens: state.general.tokens,
});

export default connect(mapStateToProps)(withTranslation()(ActivityReport));

// import React, {Component} from 'react';
// import {
//   Row,
//   Card,
//   CardBody,
//   CardTitle,
//   Col,
//   Input,
//   Button,
// } from 'reactstrap';
// import ReactTable from 'react-table';
// import {withTranslation} from 'react-i18next';
// import {Colxx} from '../components/common/CustomBootstrap';
// import {connect} from 'react-redux';
// import {reactTableText} from '../constants/configs';
// import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
// import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
// import {fixedToWithoutRound, getDatePickerProps} from '../helpers/Utils';
// import i18n from '../services/i18n';
// import JalaliUtils from '@date-io/jalaali';
// import MomentUtils from '@date-io/moment';
// import Api from '../services/Api';
// import {keyBy, isEmpty} from 'lodash';
// import moment from 'moment';
//
// class ActivityReport extends Component {
//   constructor(props) {
//     super(props);
//     this.statistics = {
//       selectedTag: null,
//       loading: false,
//       from: null,
//       to: null,
//     };
//     this.renderTokenLogoCell = this.renderTokenLogoCell.bind(this);
//   }
//
//   async componentDidMount() {
//     await this.fetchData();
//   }
//
//   fetchData = async () => {
//     const {from, to} = this.statistics;
//     const {financialGroup} = this.props;
//     this.setState({loading: true});
//     try {
//       const {data} = await Api.invoke(
//         'GET',
//         '/admin-ui/filterable-private-statistics',
//         null,
//         {
//           params: {
//             mode: 'NONE',
//             from: from ? moment(from).toISOString() : null,
//             to: to ? moment(to).toISOString() : null,
//             ...(financialGroup ? {financialGroupId: financialGroup.id} : null)
//           },
//           cancelToken: null,
//         }
//       );
//       this.setState({
//         ...this.statistics,
//         ...data,
//       });
//     } catch (e) {
//       console.log('error: ', e);
//     } finally {
//       this.setState({
//         loading: false,
//       });
//     }
//   };
//
//   getTokenDecimals = symbol => {
//     const tokens = keyBy(this.props.tokens, 'symbol');
//     if (symbol === 'TMN') return 0;
//     if (symbol === 'USDT') return 2;
//     if (tokens[symbol]) return tokens[symbol].decimalPrecision;
//     return 10;
//   };
//
//   handleDateChange = (type, date) => {
//     this.setState({
//       [type]: date,
//       selectedTag: null,
//     }, async () => {
//       await this.fetchData();
//     });
//   };
//
//   renderTokenLogoCell(props) {
//     return (
//       <img
//         className="avatar-mini"
//         src={props.value}
//         alt={props.original.name}
//       />
//     );
//   }
//
//   getColumns = t => [
//     {
//       accessor: 'logoUrl',
//       Cell: this.renderTokenLogoCell,
//       width: 60,
//     },
//     {
//       Header: t('Name'),
//       accessor: 'localeName',
//     },
//     {
//       Header: t('Deposits'),
//       accessor: 'symbol',
//       Cell: props => <span>{
//         !isEmpty(this.statistics.deposit) ?
//           fixedToWithoutRound(
//             Math.abs(this.statistics.deposit[props.value]),
//             getTokenDecimals(props.value)
//           ) :
//           null
//       }</span>
//     },
//     {
//       Header: t('Withdraws'),
//       accessor: 'symbol',
//       Cell: props => <span>{
//         !isEmpty(this.statistics.withdraw) ?
//           fixedToWithoutRound(
//             Math.abs(this.statistics.withdraw[props.value]),
//             getTokenDecimals(props.value)
//           ) :
//           null
//       }</span>
//     },
//     {
//       Header: t('Users Trades'),
//       accessor: 'symbol',
//       minWidth: 140,
//       Cell: props => <span>{
//         !isEmpty(this.statistics.user_income) ?
//           fixedToWithoutRound(
//             Math.abs(this.statistics.user_income[props.value]),
//             getTokenDecimals(props.value)
//           ) :
//           null
//       }</span>
//     },
//     {
//       Header: t('Fees'),
//       accessor: 'symbol',
//       Cell: props => <span>{
//         !isEmpty(this.statistics.fee) ?
//           fixedToWithoutRound(
//             Math.abs(this.statistics.fee[props.value]),
//             getTokenDecimals(props.value)
//           ) :
//           null
//       }</span>
//     },
//     {
//       Header: t('Referrals'),
//       accessor: 'symbol',
//       Cell: props => <span>{
//         !isEmpty(this.statistics.reward) ?
//           fixedToWithoutRound(
//             Math.abs(this.statistics.reward[props.value]),
//             getTokenDecimals(props.value)
//           ) :
//           null
//       }</span>
//     },
//   ];
//
//   onClickLast24h = () => {
//     this.setState({
//       selectedTag: 'last24h',
//       from: moment().subtract(24, 'hours'),
//       to: moment(),
//     }, this.fetchData);
//   };
//
//   onClickLast7d = () => {
//     this.setState({
//       selectedTag: 'last7d',
//       from: moment().subtract(7, 'days'),
//       to: moment(),
//     }, this.fetchData);
//   };
//
//   onClickLast30d = () => {
//     this.setState({
//       selectedTag: 'last30d',
//       from: moment().subtract(30, 'days'),
//       to: moment(),
//     }, this.fetchData);
//   };
//
//   onClickAll = () => {
//     this.setState({
//       selectedTag: null,
//       from: null,
//       to: null,
//     }, this.fetchData);
//   };
//
//   render() {
//     const {t, tokens} = this.props;
//     const {from, to, selectedTag} = this.statistics;
//     const newTokens = [...tokens];
//     return (
//       <ThemeProvider
//         theme={createMuiTheme({
//           typography: {
//             fontFamily: 'IRANSans',
//           }})
//         }
//       >
//         <MuiPickersUtilsProvider
//           utils={i18n.language === 'fa-IR' ? JalaliUtils : MomentUtils}
//           locale={i18n.language === 'fa-IR' ? 'fa' : 'en'}
//         >
//         <Row>
//           <Colxx xxs="12" className="mb-4">
//             <Card className="h-100">
//               <CardBody>
//                 <CardTitle className="text-large text-primary">
//                   {t('Users Activity Report')}
//                 </CardTitle>
//                 <Row className="mb-5">
//                   <Col className='col-6 col-lg-3'>
//                     <span>{t('start date')}</span>
//                     <DateTimePicker
//                       {...getDatePickerProps()}
//                       value={from}
//                       TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
//                       onChange={date => {
//                         this.handleDateChange('from', date);
//                       }}
//                     />
//                   </Col>
//                   <Col className='col-6 col-lg-3'>
//                     <span>{t('end date')}</span>
//                     <DateTimePicker
//                       {...getDatePickerProps()}
//                       value={to}
//                       TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
//                       onChange={date => {
//                         this.handleDateChange('to', date);
//                       }}
//                     />
//                   </Col>
//                   <Col className='col-12 col-lg-6 mt-2 mt-lg-0 d-flex flex-row align-items-end justify-content-between'>
//                     <Button outline={selectedTag !== 'last24h'} onClick={this.onClickLast24h}>{t('last 24 hours')}</Button>
//                     <Button outline={selectedTag !== 'last7d'} onClick={this.onClickLast7d}>{t('last 7 days')}</Button>
//                     <Button outline={selectedTag !== 'last30d'} onClick={this.onClickLast30d}>{t('last 30 days')}</Button>
//                     <Button outline={!!from || !!to} onClick={this.onClickAll}>{t('from first day')}</Button>
//                   </Col>
//                 </Row>
//                 <ReactTable
//                   manual
//                   className="-highlight"
//                   data={newTokens}
//                   loading={this.statistics.loading}
//                   sortable={false}
//                   resizable={true}
//                   showPagination={false}
//                   columns={this.getColumns(t)}
//                   defaultPageSize={6}
//                   style={{
//                     width: '100%'
//                   }}
//                   {...reactTableText}
//                 />
//               </CardBody>
//             </Card>
//           </Colxx>
//         </Row>
//       </MuiPickersUtilsProvider>
//     </ThemeProvider>
//     );
//   }
// }
//
// const mapStateToProps = statistics => ({
//   tokens: statistics.general.tokens,
// });
//
// export default connect(mapStateToProps)(withTranslation()(ActivityReport));
